import { format, parseISO } from "date-fns";
import { useState } from "react";
import { ApiService } from "./http.service";
import { availableHippodromes, dailyBulletin, statisticsOptions } from "../stores/statistics.store";

export let ServerTimeDifference: number = 0;
let resultsInterval: any = null;
export function getServerTime() {
  // api.start('get', env.accounting_api+'/misc/api/get-current-date/?v=' + Math.random().toString(), null, false)
  //   .then((response: any) => {
  //     if (response.status) {
  //       let serverDate = new Date(response.data.currentDate)
  //       // @ts-ignore
  //       ServerTimeDifference = (serverDate.getTime() + (serverDate.getTimezoneOffset() * 60000)) - browserDate.getTime() + (3600000 * 3);
  //       console.log('%cBrowser timedelta: ' + ServerTimeDifference + ' saniye',warninLogStyle);
  //       // console.log("%cTarayıcı Zamanı: "+browserDate, warninLogStyle);
  //       // console.log("%cSunucu Zamanı: "+new Date(response.data.currentDate), warninLogStyle);
  //       // console.log("New date time",new Date(browserDate.getTime() + ServerTimeDifference));
  //     }
  //   }).catch((e: any) => {})
}

getServerTime();

let offset = new Date().getTimezoneOffset() / 60;

export function ServerDate() {
  return new Date(new Date().getTime() + ServerTimeDifference);
}

export const normalizeTime = (timeString: string | null) => {
  if (timeString !== null) {
    const [hours, minutes, seconds] = timeString.split(":");
    const [sec, milli] = seconds.split(".");

    const normalizedSeconds = String(parseInt(sec)).padStart(2, "0");
    const normalizedMilliseconds = milli ? milli.substring(0, 2) : "00";

    return `${Number(minutes) > 0 ? Number(minutes) + "." : ""}${normalizedSeconds}.${normalizedMilliseconds}`;
  }
  return "";
};

export function formatMilliseconds(ms: any) {
  const minutes = Math.floor(ms / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  const milliseconds = ms % 1000;

  const formattedSeconds = seconds.toString().padStart(2, "0");
  const formattedMilliseconds = Math.floor(milliseconds / 10)
    .toString()
    .padStart(2, "0");

  return `${minutes}:${formattedSeconds}.${formattedMilliseconds}`;
}

export const getTrainingDistances = (trainings: any) => {
  if (!trainings) return [];
  const distances = new Set<string>();
  trainings.forEach((training: any) => {
    if (!training) return;
    Object.keys(training)
      .filter((key) => key.startsWith("training_") && key.endsWith("m"))
      .forEach((key) => distances.add(key.replace("training_", "").replace("m", "")));
  });

  return Array.from(distances)
    .filter((distance) => distance !== "200")
    .sort((a, b) => parseInt(b) - parseInt(a));
};

export function useForceUpdate() {
  // @ts-ignore
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value: any) => value + 1); // update the state to force render
}

export function dateFormat(eventDate: string) {
  let date = new Date(eventDate);
  date = new Date(date.setTime(date.getTime() - offset));
  return date.toLocaleDateString();
}

export function dateTimeFormat(eventDate: string) {
  let date = new Date(eventDate);
  date = new Date(date.setTime(date.getTime() - offset));
  return date.toLocaleDateString() + " " + date.toLocaleTimeString().slice(0, 5);
}

export function dateForRequest(date: any) {
  return format(parseISO(date.toISOString()), "yyyy-MM-dd");
}

const monthNames: any = {
  "0": "Ocak",
  "1": "Şubat",
  "2": "Mart",
  "3": "Nisan",
  "4": "Mayıs",
  "5": "Haziran",
  "6": "Temmuz",
  "7": "Ağustos",
  "8": "Eylül",
  "9": "Ekim",
  "10": "Kasım",
  "11": "Aralık",
};

export const longDays: any = {
  0: "Pazar",
  1: "Pazartesi",
  2: "Salı",
  3: "Çarşamba",
  4: "Perşembe",
  5: "Cuma",
  6: "Cumartesi",
};
export const shortDays: any = {
  0: "Pzr",
  1: "Pts",
  2: "Sal",
  3: "Çar",
  4: "Per",
  5: "Cum",
  6: "Cmt",
};

export function getDateHumanize(eventDate: string, t: any = "long") {
  var now = ServerDate();
  var date1 = new Date(now.toISOString());
  var date2 = new Date(eventDate);

  var Difference_In_Days = date2.getDate() - date1.getDate();

  let day = "";
  if (Difference_In_Days === 0) {
    day = "Bugün";
  } else if (Difference_In_Days === 1) {
    day = "Yarın";
  } else if (Difference_In_Days > 6) {
    day = date2.getDate() + " " + monthNames[String(date2.getMonth())];
  } else {
    if (t === "long") {
      day = longDays[date2.getDay()];
    } else {
      day = shortDays[date2.getDay()];
    }
  }
  return day;
}

export function dateTimeStringFormat(eventDate: string, year: any = false) {
  let date = new Date(eventDate);
  return (
    date.getDate() + " " + date.toLocaleString("tr-tr", { month: "long" }) + (year ? " " + date.getFullYear() : "")
  );
}

export function CurrencyFormat(price: any, decimal: number = 2) {
  if (decimal === 0) {
    return Number(price)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&#")
      .slice(0, -3)
      .replaceAll("#", ".");
  }
  return toFixedRound(Number(price), Number(decimal))
    .replace(/\d(?=(\d{3})+\.)/g, "$&#")
    .replaceAll(".", ",")
    .replaceAll("#", ".");
}

export function toFixedRound(value: any, pow: any) {
  let i = String(Number(value)).split(".");
  if (pow === 0) {
    return i[0];
  }
  return i[0] + "." + (i.length === 1 ? "00000000000000000".slice(0, pow) : (i[1] + "00000000000000000").slice(0, pow));
}

const { innerWidth: width } = window;
export let mobileView = width < 986 ? true : false;

export function getDateTimeHumanize(eventDate: string, t: any = "long") {
  var now = ServerDate();
  var date1 = new Date(now.toISOString());
  var date2 = new Date(eventDate);

  var Difference_In_Days = date2.getDate() - date1.getDate();
  let day = "";
  if (Difference_In_Days == 0) {
    day = "Bugün";
  } else if (Difference_In_Days == -1) {
    day = "Dün";
  } else if (Difference_In_Days == 1) {
    day = "Yarın";
  } else if (Difference_In_Days > 6) {
    day = date2.getDate() + " " + monthNames[String(date2.getMonth())];
  } else {
    if (t === "long") {
      day = longDays[date2.getDay()];
    } else {
      day = shortDays[date2.getDay()];
    }
  }
  return day + " " + date2.toLocaleTimeString().slice(0, 5);
}

type ThrottleFunc<T extends (...args: any[]) => void> = (func: T, limit: number) => (...args: Parameters<T>) => void;

export const throttle: ThrottleFunc<any> = (func, limit) => {
  let lastFunc: ReturnType<typeof setTimeout> | null = null;
  let lastRan: number | null = null;

  return function (this: any, ...args: any[]) {
    const context = this;
    const now = Date.now();

    if (lastRan === null) {
      func.apply(context, args);
      lastRan = now;
    } else {
      if (lastFunc) {
        clearTimeout(lastFunc);
      }

      lastFunc = setTimeout(() => {
        if (now - lastRan! >= limit) {
          func.apply(context, args);
          lastRan = now;
        }
      }, limit - (now - lastRan!));
    }
  };
};

export const formatTrainerName = (name: string) => {
  if (!name) return "-";
  const [firstName, lastName] = name.split(" ");
  if (!lastName) return firstName;
  return `${firstName.charAt(0)}. ${lastName}`;
};

export const handleOpenDetails = (date: any, location: any, run: any) => {
  const [year, month, day] = date.split("-");

  window.open(
    `https://4nala.com.tr/tjk-at-yarisi-sonuclari/${day}${month}${year}/${location.toLowerCase()}/${run}`,
    "_blank"
  );
};

export const getDailyBulletin = (date: any) => {
  const api = new ApiService();
  api.start("get", `https://bulletin.4nala.com/api/bulletin/${date}/`, null).then((response: any) => {
    if (response.data) {
      dailyBulletin.length = 0;
      dailyBulletin.push(...response.data);
    }
  });
};

export function formatDateForBulletin(date: any) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}${month}${year}`;
}

export function loadingAnimation(state: any) {
  let loading: any = document.getElementById("id_loaderAnimation");
  if (loading) {
    if (state) {
      loading.style.display = "block";
    } else {
      loading.style.display = "none";
    }
  }
}

export const getPrettyFormatLastSix = (last6: any) => {
  let htmlResponse = "";
  if (last6 && (last6.indexOf("K") !== -1 || last6.indexOf("C") !== -1)) {
    const lastRuns = last6.match(/.{1,2}/g);
    for (let lR of lastRuns) {
      htmlResponse += `<span class="last-run-${lR[0]}">${lR[1]}</span>`;
    }
  } else {
    htmlResponse = last6;
  }
  return htmlResponse;
};
